import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Container,
  CardFooter,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SupplierService from "../../../services/OrderingServices/SupplierService";

// Validation Schema
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  contactPerson: Yup.string(),
  email: Yup.string().email("Invalid email").required(" Email is required"),

  address: Yup.string().required("Address is required"),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
});

const SupplierForm = () => {
  const { id } = useParams();
  const [orgDetail, setOrgDetail] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrgDetail = async () => {
      try {
        const response = await SupplierService.detail(id);
        setOrgDetail(response);
      } catch (error) {}
    };
    fetchOrgDetail();
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: orgDetail?.id || "",

      name: orgDetail?.name || "",
      contactPerson: orgDetail?.contactPerson || "",
      email: orgDetail?.email || "",

      address: orgDetail?.address || "",
      phone: orgDetail?.phone || "",
      panNumber: orgDetail?.panNumber || "",
      city: orgDetail?.city || "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        if (values.id) {
          await SupplierService.update(values.id, values);
          toast.success("Supplier updated successfully.");
        } else {
          await SupplierService.create(values);
          toast.success("New supplier is added successfully");
          resetForm();
        }
        navigate("/suppliers")
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      }
    },
  });
  const breadcrumbItems = [
    { title: "Back To List", onClick: () => navigate(-1) },
  ];
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Supplier Form"
          pageTitle="Supplier"
          breadcrumbItems={breadcrumbItems}
        />
        <Card>
          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <Row>
                <Col>
                  <div className="form-floating mb-3">
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      className="form-control"
                      placeholder="Enter name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      invalid={!!(formik.touched.name && formik.errors.name)}
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="name">Supplier Name</Label>
                    {formik.touched.name && formik.errors.name && (
                      <FormFeedback type="invalid">
                        {formik.errors.name}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-floating mb-3">
                    <Input
                      id="contactPerson"
                      name="contactPerson"
                      type="text"
                      className="form-control"
                      placeholder="Enter Organization Code"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contactPerson}
                      invalid={
                        !!(
                          formik.touched.contactPerson &&
                          formik.errors.contactPerson
                        )
                      }
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="contactPerson">Contact Person</Label>
                    {formik.touched.contactPerson &&
                      formik.errors.contactPerson && (
                        <FormFeedback type="invalid">
                          {formik.errors.contactPerson}
                        </FormFeedback>
                      )}
                  </div>
                </Col>
                <Col md={6}>
                  {" "}
                  <div className="form-floating mb-3">
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control"
                      placeholder="Enter admin email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      invalid={!!(formik.touched.email && formik.errors.email)}
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="email">Email Address</Label>
                    {formik.touched.email && formik.errors.email && (
                      <FormFeedback type="invalid">
                        {formik.errors.email}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-floating mb-3">
                    <Input
                      id="phone"
                      name="phone"
                      type="text"
                      className="form-control"
                      placeholder="Enter phone number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone}
                      invalid={!!(formik.touched.phone && formik.errors.phone)}
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="phone">Phone Number</Label>
                    {formik.touched.phone && formik.errors.phone && (
                      <FormFeedback type="invalid">
                        {formik.errors.phone}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-floating mb-3">
                    <Input
                      id="address"
                      name="address"
                      type="text"
                      className="form-control"
                      placeholder="Enter address"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                      invalid={
                        !!(formik.touched.address && formik.errors.address)
                      }
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="address">Address</Label>
                    {formik.touched.address && formik.errors.address && (
                      <FormFeedback type="invalid">
                        {formik.errors.address}
                      </FormFeedback>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-floating mb-3">
                    <Input
                      id="city"
                      name="city"
                      type="text"
                      className="form-control"
                      placeholder="Enter city number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.city}
                      invalid={!!(formik.touched.city && formik.errors.city)}
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="city">City</Label>
                    {formik.touched.city && formik.errors.city && (
                      <FormFeedback type="invalid">
                        {formik.errors.city}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-floating mb-3">
                    <Input
                      id="panNumber"
                      name="panNumber"
                      type="text"
                      className="form-control"
                      placeholder="Enter panNumber number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.panNumber}
                      invalid={
                        !!(formik.touched.panNumber && formik.errors.panNumber)
                      }
                      style={{ padding: "0.5rem", height: "1rem" }}
                    />
                    <Label for="panNumber">PAN Number</Label>
                    {formik.touched.panNumber && formik.errors.panNumber && (
                      <FormFeedback type="invalid">
                        {formik.errors.panNumber}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-end align-content-center gap-3"> 

              <Link to="/suppliers">
                <Button color="danger">Cancel</Button>
              </Link>

              <Button color="success" type="submit">
                {id ? "Update" : "Create"}
              </Button>
              </div>
            </CardFooter>
          </Form>
        </Card>
      </div>
    </Container>
  );
};

export default SupplierForm;
